const generateCollectionDetailUrl = (
    type: 'owner' | 'viewer',
    shortCode: string,
    title?: string,
): string => {
    const baseUrl = process.env.NEXT_PUBLIC_AUTH_HOST_URL;
    const utm = 'utm_source=organic&utm_medium=share_collection';
    const titleSlug = title ? title.replace(/\s+/g, '-') : '';

    if (type === 'viewer')
        return `${baseUrl}/shared-collections/${titleSlug}-${shortCode}?${utm}`;

    return `${baseUrl}/user/favorite/?tab=favorite&id=${shortCode}`;
};

export default generateCollectionDetailUrl;
